module.exports = __webpack_public_path__ + "img/Support-skill-309.55c1b0d6.png";